var _a;
import { createSlice } from '@reduxjs/toolkit';
var initialState = {
    is_login: false,
    login_type: 0,
};
var isLoginSlice = createSlice({
    name: 'isLogin',
    initialState: initialState,
    reducers: {
        handleCheckLogin: function (state, action) {
            state.is_login = action.payload.is_login;
        },
        handleCheckLoginType: function (state, action) {
            state.login_type = action.payload.login_type;
        },
    },
});
export var handleCheckLogin = (_a = isLoginSlice.actions, _a.handleCheckLogin), handleCheckLoginType = _a.handleCheckLoginType;
export default isLoginSlice.reducer;
